import * as yup from 'yup';
// Strings
export const simpleStringSchema = yup.string();
export const requiredStringSchema = simpleStringSchema.required('Required');
// Numbers
export const simpleNumberSchema = yup.number();
export const requiredNumberSchema = simpleNumberSchema.required('Required');
